import { isWorkablePendingWorkspaceClient } from "../../invitations/pendingWorkspaceState";

const ACTIVE_CLIENT_STATUS = "active-string";

const normalizeStatus = (status) =>
  typeof status === "string" ? status.trim() : "";

export const SIDE_MENU_CLIENT_STATE_WRITE_TARGET = Object.freeze({
  USER: "user",
  PENDING_WORKSPACE: "pending_workspace",
  NONE: "none",
});

export const resolveSideMenuClientStateWriteTarget = (client) => {
  if (normalizeStatus(client?.status) === ACTIVE_CLIENT_STATUS) {
    return SIDE_MENU_CLIENT_STATE_WRITE_TARGET.USER;
  }

  if (isWorkablePendingWorkspaceClient(client)) {
    return SIDE_MENU_CLIENT_STATE_WRITE_TARGET.PENDING_WORKSPACE;
  }

  return SIDE_MENU_CLIENT_STATE_WRITE_TARGET.NONE;
};
